export default "__VITE_ASSET__D4f9Fz9f__"